import { useEffect } from "react";
import { CapCutNavbar } from "../components/capcut/CapCutNavbar";
import { CapCutHero } from "../components/capcut/CapCutHero";
import { CapCutMarquee } from "../components/capcut/CapCutMarquee";
import { CapCutFeatures } from "../components/capcut/CapCutFeatures";
import { CapCutComparison } from "../components/capcut/CapCutComparison";
import { CapCutPricing } from "../components/capcut/CapCutPricing";
import { CapCutDevices } from "../components/capcut/CapCutDevices";
import { CapCutSteps } from "../components/capcut/CapCutSteps";
import { CapCutTestimonials } from "../components/capcut/CapCutTestimonials";
import { CapCutFAQ } from "../components/capcut/CapCutFAQ";
import { CapCutSticky } from "../components/capcut/CapCutSticky";
import { CapCutSocialProof } from "../components/capcut/CapCutSocialProof";
import { ScrollProgress } from "../components/landing/ScrollProgress";

export default function CapCutPage() {
  useEffect(() => {
    document.title = "CapCut Pro 1 Bulan Full Akses Hanya 59rb — Hotaro Digital Store";
  }, []);

  return (
    <div className="font-capcut-body text-slate-900 bg-white">
      <ScrollProgress />
      <CapCutNavbar />
      <main>
        <CapCutHero />
        <CapCutMarquee />
        <CapCutFeatures />
        <CapCutComparison />
        <CapCutPricing />
        <CapCutDevices />
        <CapCutSteps />
        <CapCutTestimonials />
        <CapCutFAQ />
      </main>
      <footer className="bg-white border-t border-slate-200 py-12 pb-32" data-testid="capcut-footer">
        <div className="max-w-6xl mx-auto px-6 sm:px-8 text-xs leading-relaxed text-slate-400 space-y-3">
          <p className="font-bold text-slate-500 uppercase tracking-wider">Disclaimer</p>
          <p>Produk yang ditawarkan adalah layanan penyediaan akses/paket keanggotaan sesuai deskripsi yang berlaku saat pembelian.</p>
          <p>
            Kami bukan afiliasi, partner resmi, maupun perwakilan dari ByteDance Ltd. ataupun CapCut. Seluruh merek dagang, logo, dan
            nama produk merupakan milik masing-masing pemiliknya dan digunakan hanya sebagai referensi untuk menjelaskan kompatibilitas
            atau layanan yang ditawarkan.
          </p>
          <p>Harga, fitur, dan ketersediaan layanan dapat berubah mengikuti kebijakan penyedia layanan terkait.</p>
          <p className="pt-4 border-t border-slate-200 text-slate-400">© {new Date().getFullYear()} Hotaro Digital Store. Seluruh hak cipta dilindungi.</p>
        </div>
      </footer>
      <CapCutSticky />
      <CapCutSocialProof />
    </div>
  );
}
